module.exports = __webpack_public_path__ + "img/company_01.95cd2e3c.png";